import type { MiningView } from "../types";
import type { WalletSessionAction } from "../../../state/wallet-session-action";

interface MiningSessionStatusProps {
  mining: MiningView;
  sessionAction?: WalletSessionAction | null | undefined;
  settingsBusy?: boolean;
  publicMiningEnabled: boolean;
  onCheckStatus?(): void;
  onRetrySubmission(): void;
  onNewSession?(): void;
  onSavedProof?(): void;
}

export function MiningSessionStatus({ mining, sessionAction, settingsBusy = false, publicMiningEnabled,
  onCheckStatus, onRetrySubmission, onNewSession, onSavedProof }: MiningSessionStatusProps) {
  const working = ["STARTING", "MINING", "CANDIDATE_FOUND", "SUBMITTING"].includes(mining.phase);
  const statusText = sessionAction ? sessionAction.message ?? (sessionAction.kind === "wait" ? sessionAction.label :
    sessionAction.label === "Sign in again" ? "Mining paused. Sign in again; the mining deadline still applies." :
    "Sign in to start or restore mining.") : mining.authExpiring && mining.phase === "MINING" ?
    "Your sign-in expires soon. Mining will pause when it expires." : mining.statusMessage;
  return <div className="terminal-session-region">
    <p className="terminal-session-status" role="status" aria-label="Wallet session status" aria-atomic="true"
      tabIndex={statusText ? 0 : -1}>{statusText}</p>
    <div className="terminal-secondary-actions">
      {mining.sessionAction && !mining.canCreateNewSession && !sessionAction && !working && onCheckStatus ? <button type="button" onClick={onCheckStatus}
        disabled={settingsBusy || mining.sessionChecking}>Check status</button> : null}
      {mining.phase === "SUBMIT_RETRY" && mining.canRetrySubmission && mining.sessionAction && !sessionAction && !working ? <button type="button" onClick={onRetrySubmission}
        disabled={settingsBusy}>Retry saved submission</button> : null}
      {mining.canCreateNewSession && (publicMiningEnabled || mining.demoOnly) && !mining.newChallengeBlocked && onNewSession && !sessionAction ?
        <button type="button" onClick={onNewSession} disabled={settingsBusy}>New mining session</button> : null}
      {(mining.hasSavedProof || mining.hasSavedCandidate) && onSavedProof && !sessionAction && !working ? <button type="button" onClick={onSavedProof}
        title={`${mining.savedResultCount ?? 1} locally saved results. Check each in turn without resuming mining.`}
        disabled={settingsBusy || mining.newChallengeBlocked}>{(mining.savedResultCount ?? 0) > 1 ? "Next saved result" : mining.hasSavedProof ? "Check saved proof" : "Check saved result"}</button> : null}
    </div>
  </div>;
}
